import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';

const articleSlider = new Swiper(".js-articleSlider", {
    modules: [Navigation, Pagination],
    navigation: {
        prevEl: ".articleSlider__navBtn--prev",
        nextEl: ".articleSlider__navBtn--next"
    }, 
    pagination: {
        el: ".articleSlider__pagination"
    }, 
});